import React from 'react';
import Navigation from './navigation';
import Routes from './routes';
import axios from 'axios';
import {useDispatch, useSelector} from 'react-redux';
import {setAuthorize} from '../store/authorization/thunk/setAuthorize';
import Authorization from './authorization';
import {Redirect} from "react-router-dom";
import {useRouter} from '../../@casino/useRouter';
import Logo from '../../@casino/img/logo3.jpg';
import {useStyles} from './helper';
import {Route, Switch} from 'react-router-dom';

const Desktop = () => {
    const router = useRouter();
    const classes = useStyles();

    const dispatch = useDispatch();

    const token = localStorage.getItem('token');

    axios.defaults.headers.common['Authorization'] = token;

    React.useEffect(() => {
        if (!!token) {
            dispatch(setAuthorize());
        }
    }, [token])

    const isAuth = !!token;
    const view = useSelector(state => state.auth.admin);
    const authorization = useSelector(state => state.auth.authorize);

    return (
        <div className={classes.root}>
            {
                isAuth && router.pathname === '/' && authorization &&
                <Redirect to='/information'/>
            }
            {
                !isAuth &&
                <>
                    
                    <Switch>
                        <Route component={Authorization} />
                    </Switch>
                </>
            }
            {
                isAuth && authorization &&
                <>
                    <div className={classes.rootAuth}>
                        <div className={classes.wrapAuth}>
                            <img src={Logo} className={classes.logo} alt="logo"/>
                        </div>
                        <span 
                            className={classes.exit}
                            onClick={() => {
                                localStorage.removeItem('token');
                                window.location.replace(window.location.origin)
                            }}>Выход</span>
                    </div>
                    <div className={classes.body}>
                        <div className={classes.navigation} style={{overflow: 'scroll'}}>
                            <Navigation view={view} />
                        </div>
                        <div className={classes.routes}>
                            <Routes view={view}/>
                        </div>
                    </div>
                </>
            }
            
        </div>
    )
}

export default Desktop;